import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LinkRegistryService } from '../../services/link-registry.service';
import { LocaleService } from '../../services/locale/locale.service';
import { RestService } from '../../services/rest/rest.service';
import { Locale } from '../../services/locale/locale.domain';
import { IncludeService } from '../../components/include/include.service';
import { ResponseSection, ResponseArticleUrl, Topic } from './help.domain';

@Injectable({
  providedIn: 'root'
})
export class HelpRestService {
  private readonly baseUrl: string;

  constructor(private restService: RestService,
              private localeService: LocaleService,
              private linkRegistryService: LinkRegistryService,
              private includeService: IncludeService) {
    const url = this.linkRegistryService.getLink('link_help_index');
    this.baseUrl = url.substring(0, url.lastIndexOf('/'));
  }

  getIndex(): Observable<Array<Topic>> {
    const locale = this.localeService.getLocale();
    const isEn = locale === Locale.en_CA;
    return this.restService.getResource('help.index').get<{ sections: Array<ResponseSection> }>()
      .pipe(
        map((data: { sections: Array<ResponseSection> }): Array<Topic> => {
          const result: Array<Topic> = [];
          data.sections.forEach((section: ResponseSection): void => {
            const topic = {
              id: section.id,
              title: isEn ? section.text.en : section.text.fr,
              items: []
            };
            section.articles.forEach((article: ResponseArticleUrl): void => {
              const item = {
                id: article.id,
                url: article.url,
                text: isEn ? article.text.en : article.text.fr
              };
              topic.items.push(item);
            });
            result.push(topic);
          });
          return result;
        })
      );
  }

  getArticle(articleUrl: string): Observable<string> {
    return this.includeService.getHtml(this.baseUrl + '/' + articleUrl)
      .pipe(
        map((html: string): string => {
          if (html.trim().length > 0) {
            html = this.includeService.resolveForeignImgTags(html, this.baseUrl);
          }
          return html;
        })
      );
  }
}
